import { useNavigate, useSearchParams } from 'react-router-dom';
import { ProductsPage } from '@practium/features/products';
import type { ProductsPermissions, ProductsTab } from '@practium/features/products';
import { usePermissions } from '@practium/features/permissions';

const isProductsTab = (value: string | null): value is ProductsTab =>
	value === 'defensives' || value === 'fertilizers' || value === 'manufacturers';

export const ProductsPageAdmin = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const tabParam = searchParams.get('tab');
	const initialTab: ProductsTab = isProductsTab(tabParam) ? tabParam : 'defensives';
	const { abilities } = usePermissions();

	const permissions: ProductsPermissions = {
		canCreate: abilities.can('create', 'products'),
		canEdit: abilities.can('update', 'products'),
		canDelete: abilities.can('delete', 'products'),
		canEditPublic: abilities.can('update', 'products'),
	};

	const handleAddNew = (tab: ProductsTab) => {
		navigate(`/produtos/novo?type=${tab}`);
	};

	const handleViewItem = (tab: ProductsTab, id: string) => {
		navigate(`/produtos/ver?type=${tab}&id=${id}`);
	};

	return (
		<ProductsPage
			initialTab={initialTab}
			permissions={permissions}
			onAddNew={handleAddNew}
			onViewItem={handleViewItem}
			addButtonText={permissions.canCreate ? 'Adicionar' : undefined}
		/>
	);
};
